import { IApplicationState } from '../../types/redux';
import { selectProfilingCookieState } from '../cookies/selectProfilingCookieState';
import { selectIsCatProfilingMobileExperimentEnabled } from '../experiments/selectIsCatProfilingMobileExperimentEnabled';

/* istanbul ignore next */
export function selectShouldShowMobileProfilingBanner(state: IApplicationState): boolean {
  return selectIsCatProfilingMobileExperimentEnabled(state) && !selectProfilingCookieState(state);
}
